export default __webpack_public_path__ + "static/media/aiCameraButton.a4b37276.svg";